import React from 'react';
import {MESSAGE_INFO, MESSAGE_SUCCESS} from "../constants";
import {sendMessage} from "../actions";
import {useDispatch} from "react-redux";

export default function useInfoMessage() {
    const dispatch = useDispatch();

    return message => dispatch(sendMessage(MESSAGE_INFO, message));
}